import html2canvas from 'html2canvas';
import moment from 'moment';
import { useDateTimeFormat } from '@/composables/useDateTimeFormat';
const { formatDateTime } = useDateTimeFormat();
let widgetMixin = {
  methods: {
    downloadWidget(el, namedownload = 'default') {
      let fileName = '';
      const dateNow = formatDateTime().replace(/[-: "]/g, '');
      fileName += `${namedownload}_${dateNow}`;
      html2canvas(el, {
        onclone: function (clone) {
          let widgetCustom = clone.querySelector('.widget-custom');
          let monitoringStatus = clone.querySelector('.monitoring-status');
          let instanceMap = clone.querySelector('.instance-map');

          if (monitoringStatus) {
            let header = widgetCustom.getElementsByClassName('widget-header')[0];
            let title = widgetCustom.getElementsByClassName('widget-header__title_title')[0];

            if (header) {
              header.classList.add('downloadWidget');
              header.style.height = 'auto';
              header.style['min-height'] = 'auto';
            }

            if (title) {
              title.style.height = 'auto';
              title.style.display = 'block';
              title.style['word-break'] = 'break-word';
            }
          }

          if (instanceMap && widgetCustom.classList.contains('instance-map')) {
            widgetCustom.getElementsByClassName('widget-body')[0].style.height =
              instanceMap.clientHeight - 60 + 'px';
          }

          widgetCustom.classList.add('widget-custom-clone');
          const classTooltip = widgetCustom.getElementsByClassName(
            'lego-tooltip-outer-invisible-container'
          );

          while (classTooltip.length) {
            classTooltip[0].remove();
          }
        }
      }).then((canvas) => {
        const link = document.createElement('a');
        const newTitle = fileName;
        link.setAttribute('download', newTitle + '.png');
        link.setAttribute(
          'href',
          canvas.toDataURL('image/png').replace('image/png', 'image/octet-stream')
        );
        link.click();
        el.classList.remove('widget-custom');
        //canvas.toBlob((blob) => navigator.clipboard.write([new ClipboardItem({ 'image/png': blob })]));
      });
    }
  }
};
export default widgetMixin;
